import * as CONSTANT from './bible-constants';
export default CONSTANT;



//////////////////
// WEBPACK FOOTER
// ./src/fhl/constant/ns.ts
// module id = null
// module chunks = 